/**
 * Created by neo on 14.11.2023
 */
import { makeAutoObservable } from 'mobx';
import { RouteChallengeLocationPosition, createRouteChallengeLocationPosition } from './RouteChallengeLocationPosition';
import { Media, createMedia } from '../../Media/Media';
import { HttpBackend } from '../../../Services/Http/HttpBackend';
import { LocalizedEntity, createLocalizedEntity } from '../../LocalizedEntity';

export type RouteChallengeLocation = LocalizedEntity & {
  challengeId: string;
  pointsRequired: number;
  totalPointsRequired: number;
  position: RouteChallengeLocationPosition;
  image?: Media;
  medias: Media[];
  googleMapsRouteToNextLocation?: string;
};

export function createRouteChallengeLocation(json?: Partial<RouteChallengeLocation>): RouteChallengeLocation {
  const base = createLocalizedEntity(json as any);
  return makeAutoObservable({
    ...base,
    challengeId: json?.challengeId ?? '',
    pointsRequired: json?.pointsRequired ?? 0,
    totalPointsRequired: json?.totalPointsRequired ?? 0,
    position: createRouteChallengeLocationPosition(json?.position as any),
    image: json?.image ? createMedia(json.image as any) : undefined,
    medias: ((json?.medias as any) ?? []).map((media: any) => createMedia(media)),
    googleMapsRouteToNextLocation: json?.googleMapsRouteToNextLocation,
  });
}

export const RouteChallengeLocationApi = {
  findOne(locationId: string): Promise<RouteChallengeLocation> {
    return HttpBackend.get(`/coach-program/engagement/route-challenges/location/${locationId}`).then((res) =>
      createRouteChallengeLocation(res),
    );
  },
};
